export function arrayChunk(array, chunkSize) {
  return array.reduce((previous, current) => {
    let chunk;
    if (previous.length === 0 || previous[previous.length - 1].length === chunkSize) {
      chunk = [];
      previous.push(chunk);
    } else {
      chunk = previous[previous.length - 1];
    }
    chunk.push(current);
    return previous;
  }, []);
}

export function arrayContainsRequired(required, data) {
  return required.every(element => data.includes(element));
}

export function arrayHasMatchingValues(requiredValues, inputValues) {
  return inputValues.some(value => requiredValues.includes(value));
}



// WEBPACK FOOTER //
// ./src/utils/array.js